<div class="panel">
    <mat-card>
        <div class="panel__header">
            <span class="panel__header__title"><a [routerLink]="['/uc-planner']">{{'Planner' | translate | async}}</a> /
                {{'SMU & PMU Service' | translate | async}}</span>
        </div>
        <div class="row">
            <div class="panel__header__buttons" style="display: flex; float:inline-end" *ngIf="HasfavData">
                <div *ngFor="let favorite of userFavorites" class="favourites">
                    <a class="button button--hover-icon" [ngStyle]="{'background-color':favorite.BackgroundColor}">
                        <span class="button__text" [ngStyle]="{'color':favorite.TextColor}"
                            (click)="getFavorite(favorite.Id)">{{favorite.Name}}</span>
                    </a>
                </div>
                <div class="divider"></div>
                <a style="margin-top: 6px;">
                    <span style="    font-size: 18px;
                    color: black;
                    padding: 14px;"> {{'Favorites' | translate | async}}</span>
                </a>
            </div>
        </div>
        <div class="row ">
            <div class="col-lg-12">
                <mat-form-field class="col-lg-4">
                    <mat-label> {{'Customer' | translate | async}} <span style="color: red;">*</span>
                    </mat-label>
                    <input matInput #customerAutoCompleteInput (focus)="focus(1)" placeholder="Customer"
                        aria-label="customer" [matAutocomplete]="autoCustomer" [formControl]="customerCtrl"
                        ngDefaultControl>
                    <mat-autocomplete #autoCustomer="matAutocomplete"
                        (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
                        <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
                            <span>{{ customer.Title }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="col-lg-4">
                    <mat-label>
                        {{'Jobsite' | translate | async}} <span style="color: red;">*</span>
                    </mat-label>
                    <input matInput (focus)="focus(2)" #jobSiteAutoCompleteInput placeholder="JobSite"
                        aria-label="jobsite" [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl"
                        ngDefaultControl>

                    <mat-autocomplete #autoJobsite="matAutocomplete"
                        (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
                        <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
                            <span>{{ jobsite.Title }}</span>
                            <small></small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="col-lg-4">
                    <input matInput (focus)="focus(4)" #familyAutoCompleteInput
                        placeholder=" {{'Family' | translate | async}} " aria-label="Family"
                        [matAutocomplete]="autoFamily" [formControl]="familyCtrl">
                    <mat-autocomplete #autoFamily="matAutocomplete"
                        (optionSelected)="familySelected($event,familyAutoCompleteInput)">
                        <mat-option *ngFor="let family of filteredFamilies | async" [value]="family">
                            <span>{{ family.Title }}</span> |
                            <small>{{family.Symbol}}</small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field class="col-lg-4">

                    <input matInput (focus)="focus(5)" #makeAutoCompleteInput
                        placeholder="{{'Make' | translate | async}}" aria-label="Make" [matAutocomplete]="autoMake"
                        [formControl]="makeCtrl">
                    <mat-autocomplete #autoMake="matAutocomplete"
                        (optionSelected)="makeSelected($event,makeAutoCompleteInput )">
                        <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
                            <span>{{ make.Title }}</span> |
                            <small>{{make.Symbol}}</small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="col-lg-4">
                    <mat-chip-list #modelChipList>
                        <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(6)" [selectable]="false"
                            [removable]="true" (removed)="popMultipleSelection(6, item.SearchId, item.SearchStr)">
                            {{item.Title}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input matInput [matChipInputFor]="modelChipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="false"
                            (focus)="focus(6)" #modelAutoCompleteInput placeholder="{{ 'Model' | translate | async}}"
                            aria-label="Model" [matAutocomplete]="autoModel" [formControl]="modelCtrl">
                    </mat-chip-list>
                    <mat-autocomplete #autoModel="matAutocomplete" [displayWith]="modelDisplayMapper"
                        (optionSelected)="modelSelected($event,modelAutoCompleteInput)">
                        <mat-option *ngFor="let model of filteredModels | async" [value]="model">
                            <span>{{ model.Title }}</span>
                            <small></small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="row" style="text-align: right;">
            <button mat-raised-button (click)="resetFields()"> {{'Reset' | translate | async}} </button>
            <button mat-raised-button color="warn" (click)="LoadUcPlannerDetail()">
                {{'Search' | translate | async}}
            </button>
        </div>
    </mat-card>
    <div class="row" style="margin-top: 20px;">
        <div class="col-lg-4">
            <mat-card>
                <h4> {{'Enter Date For SMU' | translate | async}}</h4>
                <mat-form-field class="example-full-width">
                    <input matInput [matDatepicker]="picker" placeholder="" [(ngModel)]="SmuDate"
                        (dateChange)="SmuDateChange()">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </mat-card>
        </div>
        <div class="col-lg-4">
        </div>
    </div>
    <div style="text-align: center;">
        <mat-spinner *ngIf="dataLoading" class=""></mat-spinner>
    </div>
    <mat-card class="col-lg-12" style="padding: 20px; margin-top: 20px;" *ngIf="showTableView">
        <div style="overflow-x: auto;">
            <table class="table table--striped table--full-width">
                <thead>
                    <tr>
                        <th>{{'Model' | translate | async}}</th>
                        <th>{{'Unit No.' | translate | async}}</th>
                        <th>{{'SMU Last Known Date Header' | translate | async}}</th>
                        <th>{{'SMU Last Known SMU Header' | translate | async}}</th>
                        <th>{{'Distance Forward Header' | translate | async}} ({{userUOD}})</th>
                        <th>{{'Distance Reverse Header' | translate | async}} ({{userUOD}})</th>
                        <th>{{'Last Dist. Total Header' | translate | async}} ({{userUOD}})</th>
                        <th>{{'Last Known Dist. Date Header' | translate | async}}</th>
                        <th>{{'Enter Date' | translate | async}}</th>
                        <th>{{'Enter SMU' | translate | async}}</th>
                        <th>{{'Forward Distance Header' | translate | async}} ({{userUOD}})</th>
                        <th>{{'Reverse Distance Header' | translate | async}} ({{userUOD}})</th>
                        <th>{{'Total Distance' | translate | async}} ({{userUOD}})</th>
                        <th>{{"Close PM's" | translate | async}}</th>
                        <th>{{'Next Pm Service Header' | translate | async}}</th>
                        <th>{{'2nd Pm Service Header' | translate | async}}</th>
                        <th>{{'Floating Pm1 Service Header' | translate | async}}</th>
                        <th>{{'Floating Pm2 Service Header' | translate | async}}</th>
                        <th>{{'Actions' | translate | async}}</th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let element of UcPlannerDetail">
                        <td>{{element.ModelDesc}}</td>
                        <td>{{element.Unit}}</td>
                        <td>{{element.LastKnownDate | date:'dd MMM yyyy'}}</td>
                        <td>{{element.LastKnownSmu}}</td>
                        <td>
                            <span *ngIf="element.ForwardDistance==0">N/A</span>
                            <span *ngIf="element.ForwardDistance!=0">{{ convertDistanceKmToMi(element.ForwardDistance)
                                }}</span>
                        </td>
                        <td>
                            <span *ngIf="element.ReverseDistance==0">N/A</span>
                            <span *ngIf="element.ReverseDistance!=0">{{ convertDistanceKmToMi(element.ReverseDistance)
                                }}</span>
                        </td>
                        <td>
                            <span *ngIf="element.ForwardDistance==0 && element.ReverseDistance==0">N/A</span>
                            <span *ngIf="element.ForwardDistance!=0 && element.ReverseDistance!=0"
                                [ngClass]="{'estimated-border': element.IsEstimatedDistance}">
                                {{ convertDistanceKmToMi((+element.ForwardDistance) + (+element.ReverseDistance)) }}
                            </span>
                        </td>
                        <td>{{element.LastKnownDateDistance | date:'dd MMM yyyy'}}</td>
                        <td>
                            <mat-form-field class="date-width">
                                <input matInput [matDatepicker]="picker7" placeholder=""
                                    [(ngModel)]="element.DateEnter">
                                <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
                                <mat-datepicker #picker7></mat-datepicker>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="" value="" [(ngModel)]="element.EnterSmu"
                                    id="Smu{{element.Id}}" (focusout)="calculateDistance(element)">
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="" [(ngModel)]="element.ForwardDistanceSave"
                                    id="F{{element.Id}}" (input)="markManualEntry(element)">
                            </mat-form-field>
                        </td>

                        <td>
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="" [(ngModel)]="element.ReverseDistanceSave"
                                    id="Reverse{{element.Id}}" (input)="markManualEntry(element)">
                            </mat-form-field>
                        </td>
                        <td>
                            <span 
                                [ngClass]="{'estimated-border': element.IsEstimated}">
                                {{ +element.ForwardDistanceSave + (+element.ReverseDistanceSave) }}
                            </span>
                        </td>
                        <td><mat-icon (click)="ClosePmService(element)">settings</mat-icon></td>
                        <td>
                            <div class="column-flex">
                                <mat-form-field class="date-width"
                                    [ngClass]="{'date-warning': isPastDate(element.NextPmDate)}">
                                    <input matInput [matDatepicker]="picker" placeholder=""
                                        [(ngModel)]="element.NextPmDate" min="{{_minDateNextPm | date:'yyyy-MM-dd'}}"
                                        (dateChange)="onNextPmDateChange(1,element.NextPmDate,element)"
                                        [disabled]="element.InspectionId==0">
                                    <mat-datepicker-toggle matSuffix [for]="picker"
                                        [disabled]="element.InspectionId==0"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="date-width">
                                    <mat-select placeholder="PM Type" ngDefaultControl
                                        [(ngModel)]="element.PmServiceNextPmDate" [disabled]="!element.NextPmDate">
                                        <mat-option [value]="0">
                                            {{'None' | translate | async}}
                                        </mat-option>
                                        <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                            {{customer.TypeName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </td>
                        <td>
                            <div class="column-flex">
                                <mat-form-field class="date-width">
                                    <input matInput [matDatepicker]="picker1" placeholder=""
                                        [(ngModel)]="element.SecondPmDate"
                                        min="{{_minDateSecoundPm | date:'yyyy-MM-dd'}}"
                                        [disabled]="element.InspectionId==0"
                                        (dateChange)="onNextPmDateChange(2,element.SecondPmDate,element)">
                                    <mat-datepicker-toggle matSuffix [for]="picker1"
                                        [disabled]="element.InspectionId==0"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="date-width">
                                    <mat-select placeholder="PM Type" ngDefaultControl
                                        [(ngModel)]="element.PmServiceSecondPmDate" [disabled]="!element.SecondPmDate">
                                        <mat-option [value]="0">
                                            {{'None' | translate | async}}
                                        </mat-option>
                                        <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                            {{customer.TypeName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </td>
                        <td>
                            <div class="column-flex">
                                <mat-form-field class="date-width">
                                    <input matInput [matDatepicker]="picker2" placeholder=""
                                        [(ngModel)]="element.FloatingDate1"
                                        min="{{_minDateFlaotingDate1 | date:'yyyy-MM-dd'}}"
                                        [disabled]="element.InspectionId==0"
                                        (dateChange)="onNextPmDateChange(3,element.FloatingDate1,element)">
                                    <mat-datepicker-toggle matSuffix [for]="picker2"
                                        [disabled]="element.InspectionId==0"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="date-width">
                                    <mat-select placeholder="PM Type" ngDefaultControl
                                        [(ngModel)]="element.PmServiceFloatingDate1"
                                        [disabled]="!element.FloatingDate1">
                                        <mat-option [value]="0">
                                            {{'None' | translate | async}}
                                        </mat-option>
                                        <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                            {{customer.TypeName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </td>
                        <td>
                            <div class="column-flex">
                                <mat-form-field class="date-width">
                                    <input matInput [matDatepicker]="picker3" placeholder=""
                                        [(ngModel)]="element.FloatingDate2" min="{{FloatingDate2 | date:'yyyy-MM-dd'}}"
                                        [disabled]="element.InspectionId==0"
                                        (dateChange)="onNextPmDateChange(3,element.FloatingDate2,element)">
                                    <mat-datepicker-toggle matSuffix [for]="picker3"
                                        [disabled]="element.InspectionId==0"></mat-datepicker-toggle>
                                    <mat-datepicker #picker3></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field class="date-width">
                                    <mat-select placeholder="PM Type" ngDefaultControl
                                        [(ngModel)]="element.PmServiceFloatingDate2"
                                        [disabled]="!element.FloatingDate2">
                                        <mat-option [value]="0">
                                            {{'None' | translate | async}}
                                        </mat-option>
                                        <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                            {{customer.TypeName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </td>
                        <td>
                            <button mat-raised-button color="warn" (click)="updateMeterClicked(element)">
                                {{'Save' | translate | async}}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="UcPlannerDetail.length === 0" class="no-data"> {{'No data available' | translate | async}}!
            </div>
        </div>
    </mat-card>
</div>


<div class="popup-backdrop" *ngIf="showConfirm">
    <div class="popup-box">
        <p>{{'The data will be cleared, are you sure' | translate | async}}?</p>
        <div class="popup-actions">
            <button mat-raised-button (click)="cancelClear()">
                {{'No' | translate | async}}
            </button>
            <button mat-raised-button color="warn" (click)="confirmClear()">{{'Yes' | translate | async}} </button>

            <!-- <button (click)="confirmClear()">Yes</button>
        <button (click)="cancelClear()">No</button> -->
        </div>
    </div>
</div>